const colors = [
    '#FFFFFF',
    '#D9D9D9',
    '#8C5252',
    '#202020',
    '#E52525',
    '#FF9900',
    '#0A48E7',
    '#86A8FF',
    '#1C274C',
    '#FFD800',
];

export default colors;
